import { MAX_PERIODS_TO_SHOW } from './const';

// 100年表示でヘッダー表示を間引く関数
export const shouldShowPeriod = (index: number, totalPeriods: number): boolean => {
  if (totalPeriods <= MAX_PERIODS_TO_SHOW) {
    return true;
  }

  if (totalPeriods > 200) return index % 20 === 0;
  if (totalPeriods > 100) return index % 10 === 0;
  if (totalPeriods > 50) return index % 5 === 0;
  if (totalPeriods > 20) return index % 2 === 0;

  const interval = Math.ceil(totalPeriods / MAX_PERIODS_TO_SHOW);
  return index % interval === 0;
};
